import ErrorNoti from 'components/common/ErrorNoti';
import Loading from 'components/common/Loading';
import NotificationTable from 'components/notification/NotificationTable';
import useNotificationPage from 'hooks/notification/useNotificationPage';
import styled, { css } from 'styled-components';

const NotificationPage = () => {
  const { loading, error } = useNotificationPage();

  return (
    <>
      {loading ? <Loading /> : error && <ErrorNoti />}
      <NotificationPageBlock loading={String(loading)} error={error}>
        <div className="title">알림</div>
        <NotificationTable />
      </NotificationPageBlock>
    </>
  );
};

export default NotificationPage;

const NotificationPageBlock = styled.div`
  width: 768px;
  margin: 0 auto;

  .title {
    margin-top: 2rem;
    font-size: 1.4rem;
    font-weight: bold;
    text-align: center;
  }

  ${props =>
    (props.loading === 'true' || props.error) &&
    css`
      display: none;
    `}
`;
